import ChapterItemComponent from "@common/chapters/ChapterItemComponent"
import { IconImageM } from "@common/components/icons/IconsM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import React, { useContext } from "react"
import { Dimensions, View } from "react-native"
import TouchableRippleM from "../../components/button/TouchableRippleM"
import { FontAwesome5 } from "@expo/vector-icons"

const StudyItemComponent = (props) => {
    const { item, schoolSubjects, onPress = () => {}, highlighted = false, disabled = false, showChapterProgress = false } = props

    const dimensions = useContext(DimensionsContext)

    // Tutor view: reuse the existing chapter card so the per-student progress
    // bar (derived from StudentChapter activities) shows at a glance. Flatten
    // student_chapters[0] so its XP fields sit at the chapter root — as
    // ChapterItemComponent expects — restoring the real chapter id (the spread
    // overwrites it with the student-chapter id).
    if (showChapterProgress) {
        const studentChapter = item.chapter?.student_chapters?.[0]
        const chapterWithProgress = {
            ...item.chapter,
            ...studentChapter,
            id: item.chapter?.id,
        }
        const itemWidth =
            (dimensions?.width ?? Dimensions.get("window").width) - 80

        return (
            <ChapterItemComponent
                chapter={chapterWithProgress}
                withParentChapter
                width={itemWidth}
                isHighlighted={highlighted}
                forceDisabled={highlighted || disabled}
                onPress={onPress}
                hideLevelBadge
                hideProgressNumbers
                style={{ marginBottom: 10 }}
            />
        )
    }

    const subject = schoolSubjects ? schoolSubjects?.find(
        (s) => s.id === item.chapter?.school_subject_id
    ) : item.chapter.subject

    return (
        <TouchableRippleM
            style={{
                backgroundColor: highlighted
                    ? theme.colors.primaryLighter
                    : theme.colors.white,
                borderWidth: 1,
                borderColor: highlighted ? theme.colors.primary : theme.colors.lightMore,
                borderRadius: 10,
                padding: 15,
                marginBottom: 10,
                flexDirection: "row",
                alignItems: "center",
                opacity: highlighted ? 1 : 0.9,
            }}
            onPress={onPress}
            disabled={highlighted || disabled}
        >
            {subject?.icon && (
                <IconImageM
                    uri={subject.icon}
                    width={40}
                    style={{ marginRight: 10 }}
                />
            )}
            <View style={{ flex: 1 }}>
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                    <TextM
                        color={subject?.color || theme.colors.primary}
                        fontWeight="SemiBold"
                        fontSize={14}
                        wrap
                        style={{ flex: 1 }}
                    >
                        {item.chapter?.name}
                    </TextM>
                    {highlighted && (
                        <View style={{
                            backgroundColor: theme.colors.success,
                            paddingHorizontal: 8,
                            paddingVertical: 4,
                            borderRadius: 12,
                            marginLeft: 8,
                            flexDirection: 'row',
                            alignItems: 'center'
                        }}>
                            <FontAwesome5
                                name="check"
                                size={10}
                                color={theme.colors.white}
                                style={{ marginRight: 4 }}
                            />
                            <TextM
                                fontSize={10}
                                color={theme.colors.white}
                                fontWeight="Bold"
                            >
                                Sélectionné
                            </TextM>
                        </View>
                    )}
                </View>
                <TextM
                    fontSize={12}
                    color={theme.colors.grey}
                    style={{ marginTop: 2 }}
                >
                    {subject?.name} {item.duration ? " • "+item.duration+"h" : ""}
                </TextM>
            </View>
        </TouchableRippleM>
    )
}

export default StudyItemComponent
